import React, { useState } from 'react';
import { Form, Input, Button, message, Card } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import axios from 'axios';

function PortalLogin() {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const r = await axios.post('/api/portal/login', values);
      localStorage.setItem('portal_token', r.data.token);
      localStorage.setItem('portal_nome', r.data.nome);
      window.location.href = '/portal';
    } catch(e) {
      message.error(e.response?.data?.erro || 'Email ou senha incorretos');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #001529 0%, #003a6b 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <Card style={{ width: 400, borderRadius: 16, boxShadow: '0 8px 32px rgba(0,0,0,0.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="/logo.png" alt="Celum" style={{ height: 60, marginBottom: 8 }} />
          <div style={{ fontSize: 13, color: '#888' }}>Portal do Cliente</div>
        </div>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="email" rules={[{ required: true, type: 'email', message: 'Informe um email válido' }]}>
            <Input prefix={<UserOutlined />} placeholder="Email" size="large" />
          </Form.Item>
          <Form.Item name="senha" rules={[{ required: true, message: 'Informe a senha' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Senha" size="large" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block size="large" loading={loading} style={{ marginTop: 8 }}>
            Entrar
          </Button>
        </Form>
        <div style={{ textAlign: 'center', fontSize: 11, color: '#bbb', marginTop: 20 }}>
          Celum Inspeções Técnicas e Comércio LTDA
        </div>
      </Card>
    </div>
  );
}

export default PortalLogin;
